import React from "react";

const PortfolioModal = () => {
  return (
    <div
      className="modal fade"
      id="portfolio-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="portfolio-modal"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <PortfolioModalCard
            dataName="site1"
            title="Product Shopping Website 1"
            description="This is a product shopping website with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="March, 2018"
            imgPaths={[
              "website1-cover.PNG",
              "website1-1.PNG",
              "website1-2.PNG",
              "website1-3.PNG",
              "website1-4.PNG",
              "website1-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site2"
            title="Product Shopping Website 2"
            description="This is a product shopping website with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="August, 2019"
            imgPaths={[
              "website2-cover.PNG",
              "website2-1.PNG",
              "website2-2.PNG",
              "website2-3.PNG",
              "website2-4.PNG",
              "website2-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site3"
            title="Health Product Website 1"
            description="This is a website for health related articles and products with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="September, 2019"
            imgPaths={[
              "website3-cover.PNG",
              "website3-1.PNG",
              "website3-2.PNG",
              "website3-3.PNG",
              "website3-4.PNG",
              "website3-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site4"
            title="Shopping Website 3"
            description="This is a product shopping website with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="August, 2020"
            imgPaths={[
              "website4-cover.PNG",
              "website4-1.PNG",
              "website4-2.PNG",
              "website4-3.PNG",
              "website4-4.PNG",
              "website4-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site5"
            title="Shopping Website 4"
            description="This is a product shopping website with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="October, 2019"
            imgPaths={[
              "website5-cover.PNG",
              "website5-1.PNG",
              "website5-2.PNG",
              "website5-3.PNG",
              "website5-4.PNG",
              "website5-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site6"
            title="Shopping Site 5"
            description="This is a product shopping website with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="September, 2019"
            imgPaths={[
              "website6-cover.PNG",
              "website6-1.PNG",
              "website6-2.PNG",
              "website6-3.PNG",
              "website6-4.PNG",
              "website6-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site7"
            title="Health Blog Site"
            description="This is a website for health related articles and products with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="September, 2020"
            imgPaths={[
              "website7-cover.PNG",
              "website7-1.PNG",
              "website7-2.PNG",
              "website7-3.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site8"
            title="Shopping Site 6"
            description="This is a product shopping website with custom design and 5 major pages. It has a search, category as well as product detail page. All pages are completely responsive and highly optimized. This website also has a custom blog website associated with it."
            stack="HTML, CSS, Javascript, JQuery, CakePHP | Blog: Wordpress"
            date="February, 2018"
            imgPaths={[
              "website8-cover.PNG",
              "website8-1.PNG",
              "website8-2.PNG",
              "website8-3.PNG",
              "website8-4.PNG",
              "website8-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site9"
            title="Cellphones Compare Site"
            description="This is a cellphone product and comparison site with 5 major pages. It has a search, category, product detail as well as compare page. All pages are completely responsive and highly optimized. It is built on react with server-side rendering. This website also has a custom blog website associated with it."
            stack="React, NextJS, PostCSS, NodeJS, MongoDB | Blog: Wordpress"
            date="November, 2018"
            imgPaths={[
              "website9-cover.PNG",
              "website9-1.PNG",
              "website9-2.PNG",
              "website9-3.PNG",
              "website9-4.PNG",
              "website9-5.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site10"
            title="Product Comparison Site"
            description="This is a multi-category product and comparison site with 5 major pages. It has a search, category, product detail as well as compare page. All pages are completely responsive and highly optimized. It is built on react with server-side rendering. This website also has a custom blog website associated with it."
            stack="React, NextJS, PostCSS, NodeJS, MongoDB | Blog: Wordpress"
            date="December, 2019"
            imgPaths={[
              "website10-cover.PNG",
              "website10-1.PNG",
              "website10-2.PNG",
              "website10-3.PNG",
              "website10-4.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site11"
            title="Product Compare Site 3"
            description="This is an automobile comparison site with 5 major pages. It has a search, category, product detail as well as compare page. All pages are completely responsive and highly optimized. It is built on react with server-side rendering. This website also has a custom blog website associated with it."
            stack="React, NextJS, PostCSS, NodeJS, MongoDB | Blog: Wordpress"
            date="January, 2020"
            imgPaths={[
              "website11-cover.PNG",
              "website11-1.PNG",
              "website11-2.PNG",
              "website11-3.PNG",
              "website11-4.PNG",
              "website11-5.PNG",
              "website11-6.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site12"
            title="College Compare Site 1"
            description="This is a college and university comparison site with 5 major pages. It has a search, category, product detail as well as compare page. All pages are completely responsive and highly optimized. It is built on react with server-side rendering. This website also has a custom blog website associated with it."
            stack="React, NextJS, PostCSS, NodeJS, MongoDB | Blog: Wordpress"
            date="July, 2018"
            imgPaths={[
              "website12-cover.PNG",
              "website12-1.PNG",
              "website12-2.PNG",
              "website12-3.PNG",
              "website12-4.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site13"
            title="College Compare Site 2"
            description="This is a college and university comparison site with 5 major pages. It has a search, category, product detail as well as compare page. All pages are completely responsive and highly optimized. It is built on react with server-side rendering. This website also has a custom blog website associated with it."
            stack="React, NextJS, PostCSS, NodeJS, MongoDB | Blog: Wordpress"
            date="July, 2019"
            imgPaths={[
              "website13-cover.PNG",
              "website13-1.PNG",
              "website13-2.PNG",
              "website13-3.PNG",
              "website13-4.PNG",
              "website13-5.PNG",
              "website13-6.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site14"
            title="Credit Card Compare Site"
            description="This is a credit card comparison site with 5 major pages. It has a search, category, product detail as well as compare page. All pages are completely responsive and highly optimized. It is built on react with server-side rendering. This website also has a custom blog website associated with it."
            stack="React, NextJS, PostCSS, NodeJS, MongoDB | Blog: Wordpress"
            date="August, 2018"
            imgPaths={[
              "website14-cover.PNG",
              "website14-1.PNG",
              "website14-2.PNG",
              "website14-3.PNG",
              "website14-4.PNG",
            ]}
          />
          <PortfolioModalCard
            dataName="site15"
            title="Engaging Content Website"
            description="This is an user engagement website with news, trivias and articles for fun and entertainment. All pages are completely responsive and highly optimized."
            stack="HTML, CSS, Javascript, Wordpress, SCSS"
            date="January, 2020"
            imgPaths={[
              "website15-cover.PNG",
              "website15-1.PNG",
              "website15-2.PNG",
              "website15-3.PNG",
              "website15-4.PNG",
              "website15-5.PNG",
              "website15-6.PNG",
            ]}
          />

          <PortfolioModalCard
            dataName="site16"
            title="Celeb News &amp; Info Website"
            description="This is an user engagement website with news, trivias and articles for fun and entertainment. All pages are completely responsive and highly optimized."
            stack="HTML, CSS, Javascript, Wordpress, SCSS"
            date="February, 2021"
            imgPaths={[
              "website16-cover.PNG",
              "website16-1.PNG",
              "website16-2.PNG",
              "website16-3.PNG",
              "website16-4.PNG",
              "website16-5.PNG",
            ]}
          />

          <PortfolioModalCard
            dataName="site17"
            title="Vow Gold Investment"
            description="This is a mobile application for android that allows customers to sign-up for a gold investment plan and helps them pay monthly installments towards their gold purchase with email notifications and live market gold rate updated every 30 mins"
            stack="HTML, CSS, Ionic, Cordova, Laravel, MySQL"
            date="November, 2020"
            imgPaths={[
              "website17-cover.PNG",
              "website17-1.jpg",
              "website17-2.png",
              "website17-3.png",
              "website17-4.jpg",
              "website17-5.jpg",
              "website17-6.jpg",
              "website17-7.png",
            ]}
            isVertical={true}
          />

          <PortfolioModalCard
            dataName="site18"
            title="Vow Collection"
            description="This is an e-commerce website for a client based in Mumbai. The website displays all kinds of jewelry and allows customers to select and order the jewelry of their choice"
            stack="Wix.com"
            date="March, 2021"
            imgPaths={[
              "website18-cover.PNG",
              "website18-1.PNG",
              "website18-2.PNG",
              "website18-3.PNG",
              "website18-4.PNG",
            ]}
            isVertical={true}
          />
        </div>
      </div>
    </div>
  );
};

const PortfolioModalCard = ({
  dataName,
  title,
  description,
  stack,
  date,
  imgPaths,
  isVertical = false,
}) => {
  return (
    <div className="modal-body" data-name={dataName}>
      <div className="modal-title">
        <h1>
          <span className="point">{title}</span>
        </h1>
      </div>
      <div className="modal-description">
        <p>{description}</p>
      </div>
      <div className="about-me-info">
        <p>
          <span className="span-title">Stack</span>
          <span>{stack}</span>
        </p>
        <p>
          <span className="span-title">Date</span>
          <span>{date}</span>
        </p>
      </div>
      <div id={"carousel-" + dataName} className="carousel slide">
        <ol className="carousel-indicators">
          {imgPaths.map((img, index) => {
            return (
              <li
                data-target={"#carousel-" + dataName}
                data-slide-to={index}
                className={`${index === 0 ? "active" : ""}`}
                key={img}
              ></li>
            );
          })}
        </ol>

        <div className="carousel-inner">
          {imgPaths.map((img, index) => {
            return (
              <div
                className={`${index === 0 ? "item active" : "item"}`}
                key={img}
              >
                <img
                  loading="lazy"
                  src={require("../assets/images/" + img)}
                  alt={title}
                  className={isVertical ? "v-img" : "h-img"}
                />
              </div>
            );
          })}
        </div>

        <a
          className="left carousel-control"
          href={"#carousel-" + dataName}
          data-slide="prev"
        >
          <span className="mdi fonts-icons modal-icon mdi-arrow-left-bold-circle-outline"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="right carousel-control"
          href={"#carousel-" + dataName}
          data-slide="next"
        >
          <span className="mdi fonts-icons modal-icon mdi-arrow-right-bold-circle-outline"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
      <div className="about-btns">
        <a href="#" className="site-btn" data-dismiss="modal">
          BACK TO CV
        </a>
      </div>
    </div>
  );
};

export default PortfolioModal;
